import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  notifications: [],
  notificationStatus: '',
};

const notifierSlice = createSlice({
  name: 'notifier',
  initialState,
  reducers: {
    setNotificationStatus(state, action) {
      state.notificationStatus = action.payload;
    },
    clearNotificationStatus(state) {
      state.notificationStatus = '';
    },
    addSnackbar(state, action) {
      state.notifications = [
        ...state.notifications,
        {
          ...action.payload,
        },
      ];
    },
    deleteSnackbar(state, action) {
      state.notifications = state.notifications.filter((notification) => notification.key !== action.payload);
    },
  },
});

export const { addSnackbar, deleteSnackbar, setNotificationStatus, clearNotificationStatus } = notifierSlice.actions;

export default notifierSlice.reducer;
